import nodeFetch from 'node-fetch';

interface Logger {
  error: (message: string) => void;
  debug: (message: string) => void;
}
// Check if running in a web environment and export the appropriate fetch method.
const isomorphicFetch =
  process.env.REACT_APP_ENV === 'web'
    ? window.fetch.bind(window)
    : (
        url: string,
        options: RequestInit = {},
        logger?: Logger
      ): Promise<Response> => {
        const controller = new AbortController();
        const rejectTimeout =
          Number(process.env.TIMEOUT_FOR_REJECT_REQUEST) || 10000;

        const timeout = setTimeout(() => {
          logger?.error(
            `Request ${url} rejected, timed out in ${rejectTimeout} ms`
          );
          controller.abort();
        }, rejectTimeout);

        const path = `${process.env.SSR_PROXY_TARGET}${url}`;
        logger?.debug(`Loading information by URL: "${path}"`);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return nodeFetch(path, { ...options, signal: controller.signal }).then(
          (response) => {
            clearTimeout(timeout);
            return response;
          }
        );
      };

export default isomorphicFetch;
